import React from "react";
import { Stack, Skeleton, Box} from '@chakra-ui/react';
import PageTitle from "./PageTitle";
import { LoadingBlock } from "./LoadingBlock";

export class LoadingPage extends React.Component<{pageTitle: string}> {
    render() {
        return (<>
            <PageTitle>{this.props.pageTitle}</PageTitle>
            <Box w="fill" m={20}>
                <LoadingBlock/>
            </Box>
        </>);
    }
}
